let trackingItems;
const offsetCoef = 0.66;

const scrollspy = function (trackingItemsSelector){
    const items = document.querySelectorAll(trackingItemsSelector);
    
    if(items.length === 0){
        return;
    }else{
        trackingItems = Array.from(items);
    }

    window.addEventListener("scroll", checkItemsInView);
    checkItemsInView();
}

function checkItemsInView() {
    let allItemsShowed = true;

    trackingItems.forEach(item => {
        if (!item.classList.contains("_inView")) {
            if (checkIsElementInView(item)) {
                item.classList.add("_inView");
            }
            else {
                allItemsShowed = false;
            }
        }
    });

    if (allItemsShowed) {
        window.removeEventListener("scroll", checkItemsInView);
    }
}

function checkIsElementInView(element) {
    const elRect = element.getBoundingClientRect();
    return elRect.top <= window.innerHeight  * offsetCoef;
}

const controller = {
    init: scrollspy
}

export default controller;


// WEBPACK FOOTER //
// ./uPortal/Content/js/Plugins/Scrollspy/index.js